// contacts
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";
import WebbModuleInfo from "../webx/webb-module-info";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { NetworkInvite } from "../../services/srvc-network-realm";

// code --------------->
import { Form, Input, Button, Result, Space  } from 'antd';
const { TextArea } = Input;


export default function NetworkInviteModule() {

  const usxx = GetUserForm();
  const asset = {usid: '6846dd6921014269bbb309a1e6778f088'} // GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [done, setDone] = useState(false);
  const [check, setCheck] = useState(true);

  const history = useHistory();
  const [data, setData] = useState()


  // useEffect for form validation
  useEffect( () => {
    // setCheck(false);
    // if (data.name!=='' && data.memo!=='' && file!=='')  setCheck(true);
  },[data]);

  const onFinish = async (values) => {

    setSubmit(true)
    setLoading(true)
    
    const datx = {
      name: values.name ??= '***',
      memo: values.memo ??= '***',
    }
    console.log (datx)

    // const result = await NetworkInvite({data: datx, user: asset.usid})

    // if (result.data) {
    //   setDone(true)
    // }
    // else {setDone(false)}
    setLoading(false)

  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  if (loading) return <WebbLoader/>

  return (
  <>
    {/* info */}
    <div className={submit ? 'd-none' : ''}>
      <WebbModuleInfo data={{text:'Invite Connections'}} />
      <WebbDividerSmall />
    </div>
    
    {/* data */}
    <div className={submit ? 'd-none' : ''}>
      <Form
        name="data"
        layout="vertical"
        initialValues={{ }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter Name' }]}
      >
        <Input placeholder="User Name" className="height-md rounded-wd"/>
      </Form.Item>

      <Form.Item
        label="Mail"
        name="mail"
        rules={[{ required: true, message: 'Please enter email' }]}
      >
        <Input placeholder="alice@minti.fi" className="height-md rounded-wd"/>
      </Form.Item>


      <WebbDividerMedium />
      <WebbDividerMedium />

        <Form.Item wrapperCol={{}}>
          <Button 
            type="primary" htmlType="submit" 
            className="height-md rounded-wd back-color-next border-none" 
            disabled={!check}
            style={{width:'100%'}}
          >
            Send Invite
          </Button>
        </Form.Item>
      </Form>
    </div>


    {/* action */}
    <div className={submit ? 'back-color-wite p-3 text-center rounded-wd' : 'd-none'}>
      <WebbDividerSmall />
      
      <Result
        status="success"
        title="Congratulations!"
        subTitle="Your Collectino is Created."
        className={done ? '' : 'd-none'}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/home`)}>
            Home
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          New Invite</Button>,
        ]}
      />
      
      <Result
        status="warning"
        title="Error!"
        subTitle="Please try again."
        className={done ? 'd-none' : ''}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/vault`)}>
            Home
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          Try Again</Button>,
        ]}
      />

    </div>


  </>

  )
}